import { ChangeDetectorRef, Component } from '@angular/core';
import { SalesQuoteService } from '../../service/sales-quote.service';
import { ApprovatorUser, PageRequest, PageResponse, Quotation, State } from '../../clients/interface/data.interface';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { map, of, filter, tap, catchError, EMPTY, Observable, switchMap, finalize } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DetailSimulationModalComponent } from './modals/detail-simulation-modal/detail-simulation-modal.component';
import { LoadingInfoModalComponent } from 'src/app/common/components/loading-info-modal/loading-info-modal.component';
import Swal from 'sweetalert2';
import { ModalResolutionDiscountComponent } from './modals/modal-resolution-discount/modal-resolution-discount.component';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';
import { SalesQuoteDetailModalService } from 'src/app/services/modals/sales-quote-detail-modal.service';

@Component({
  selector: 'app-view-deals-simulations',
  templateUrl: './view-deals-simulations.component.html',
  styleUrl: './view-deals-simulations.component.scss'
})
export class ViewDealsSimulationsComponent {
  public load: boolean = true;
  public cotizaciones: Quotation[];
  public responsePage: PageResponse;
  public states: State[];
  public approvators: ApprovatorUser[];
  private intervalId: any;
  public pageRequest: PageRequest = {
    states: "-12,-7",
    page: 1,
    pageSize: 10,
    search: "",
    orderDirection: "",
    orderBy: "",
    approvatorId: 0
  };

  constructor(private quoteService: SalesQuoteService,
    private dialog: MatDialog,
    private salesQuoteDetailModalService: SalesQuoteDetailModalService,
    private authService: AuthService,
    private cdRef: ChangeDetectorRef, private activatedRoute: ActivatedRoute) {

    this.pageRequest = {
      ...this.pageRequest
    };
    this.activatedRoute.paramMap
      .pipe(
        map((params: ParamMap) => {
          let id = params.get('id');
          return id ? Number(id) : undefined;
        }),
        filter((id): id is number => id !== undefined && !isNaN(id)),
        switchMap((id) => this.viewDetailSimulation(id))
      ).subscribe((res) => {
        this.getCotizaciones();
      }
    )
  }

  ngOnInit(): void { 
    this.getStates();
    this.getApprovators();
    this.startAutoRefresh();
  }

  public receiveSelectedQuote(quote: Quotation) {
    this.viewDetailSimulation(quote.id)
    .subscribe((res) => {
      console.log('Result after closed modal from selecting in table', res);
      this.getCotizaciones();
    });
  }

  private viewDetailSimulation(id: number, isFromRedirect: boolean = false): Observable<void> {
    if(this.authService.hasExpiredToken()){
      return EMPTY;
    }
    return this.salesQuoteDetailModalService.openSalesQuoteDetailById(id);
  }

  ngOnDestroy(): void {
    this.stopAutoRefresh();
  }

  public getCotizaciones() {
    this.quoteService.getCotizaciones(this.pageRequest).subscribe({
      next: (res)=> {
        this.responsePage = res;
        this.cotizaciones = res.data;
        this.load = false; 
      },
      error: (err)=>{console.log(err)}
    })
  }

  public getStates() {
    this.quoteService.getStateCotizaciones().subscribe({
      next: (res)=> {
        this.states = res;
        this.cdRef.detectChanges()
      },
      error: (err)=>{console.log(err)}
    })
  }

  public getApprovators() {
    const aprovatorAll : ApprovatorUser =  {
      id: 0,
      name: "Todos",
      rut: "0",
      maxDiscountAllowed: 100,
      phone: "0",
      email: "0",
    };
    this.quoteService.getApprovators().subscribe({
      next: (res)=> {
        this.approvators = res;
        this.approvators.unshift(aprovatorAll);
        this.cdRef.detectChanges()
      },
      error: (err)=>{console.log(err)}
    })
  }

  public onPagination(event: any) {
    this.load = true;
    this.pageRequest.page = event.page; 
    this.pageRequest.pageSize = event.pageSize; 
    this.getCotizaciones();
  }

  public onSearchInput(searchInput: string) {
    this.load = true;
    this.pageRequest = {
      ...this.pageRequest,
      page: 1,
      search: searchInput,
    };
    console.log(this.pageRequest);
    this.getCotizaciones();
  }

  public onSearchState(searchState: string) {
    this.load = true;
    this.pageRequest = {
      ...this.pageRequest,
      page: 1,
      states: searchState,
    };
    console.log(this.pageRequest);
    this.getCotizaciones();
  }

  public onSearchAprove(searchAproveId: number) {
    this.load = true;
    this.pageRequest = {
      ...this.pageRequest,
      page: 1,
      approvatorId: searchAproveId,
    };
    console.log(this.pageRequest);
    this.getCotizaciones();
  }

  public onSort(event: any) {
    this.load = true;
    this.pageRequest = {
      ...this.pageRequest,
      page: 1,
      orderBy: event?.orderBy || '',
      orderDirection: event?.orderDirection || ''
    };
    console.log(this.pageRequest);
    this.getCotizaciones();
  }

  public reload(event: any) {
    this.load = true;
    this.pageRequest = {
      ...this.pageRequest
    };
    console.log(this.pageRequest);
    this.getCotizaciones();
  }

  public startAutoRefresh(): void {
    this.intervalId = setInterval(() => {
      this.getCotizaciones();
    }, 60000); // 60000 ms = 1 minuto
  }

  public stopAutoRefresh(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

}